import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "allButton"]

  connect() {
    this.activeFilters = []
    this.updateAllButtonStyle()
  }

  filter(event) {
    event.preventDefault();
    let filterType = event.currentTarget.getAttribute("data-filter-class")
    const img = event.currentTarget.querySelector("img")

    // Capitalize the first letter
    filterType = filterType.charAt(0).toUpperCase() + filterType.slice(1)

    const isActive = this.activeFilters.includes(filterType)

    if (filterType.toLowerCase() === "all") {
      this.activeFilters = []
      this.showAllItems()
    } else {
      if (isActive) {
        this.activeFilters = this.activeFilters.filter(f => f !== filterType)
        event.currentTarget.classList.remove("active")
        if (img) img.classList.add("opacity-60")
      } else {
        this.activeFilters.push(filterType)
        event.currentTarget.classList.add("active")
        if (img) img.classList.remove("opacity-60")
      }
    }

    this.updateAllButtonStyle();
    this.reloadDataTable();
  }

  showAllItems() {
    this.filterTargets.forEach(f => {
      f.classList.remove("active")
      const img = f.querySelector("img")
      if (img) img.classList.add("opacity-60")
    })
    this.reloadDataTable();
  }

  updateAllButtonStyle() {
    if (this.activeFilters.length === 0) {
      this.allButtonTarget.classList.add("text-disabled-green")
      this.allButtonTarget.classList.remove("text-green-dark-background")
    } else {
      this.allButtonTarget.classList.remove("text-disabled-green")
      this.allButtonTarget.classList.add("text-green-dark-background")
    }
  }

  reloadDataTable() {
    const dataTable = $(this.element).find('table').DataTable();
    if (dataTable) {
      dataTable.ajax.reload();
    }
  }
}
